module.exports = __webpack_public_path__ + "assets/img/vic@2x.266bda50.png";